"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenHouseReservablesAndBestReservables = void 0;
var showings_1 = require("../showings");
var getOpenHouseReservablesAndBestReservables = function (reservedShowings, unreservedShowings) {
    var onlyOnePerDay = true;
    var reservedShowingsByDay = showings_1.groupByDays(reservedShowings, onlyOnePerDay);
    var unreservedByDay = showings_1.groupByDays(unreservedShowings);
    var bestReservables = [];
    var reservables = [];
    Object.entries(unreservedByDay).forEach(function (_a) {
        var showingsDay = _a[0], withoutReservationsOfTheDay = _a[1];
        // if unreserveds are not on a reserved day, return as reservable
        if (!reservedShowingsByDay[showingsDay]) {
            reservables = __spreadArrays(reservables, withoutReservationsOfTheDay);
        }
    });
    Object.values(reservedShowingsByDay).forEach(function (reservedShowingsOfTheDay) {
        if (reservedShowingsOfTheDay[0]) {
            // only first bestReservable of the day
            bestReservables = __spreadArrays(bestReservables, [reservedShowingsOfTheDay[0]]);
        }
    });
    return { bestReservables: bestReservables, reservables: reservables };
};
exports.getOpenHouseReservablesAndBestReservables = getOpenHouseReservablesAndBestReservables;
//# sourceMappingURL=openHouseReservables.js.map